import {
useLoaderData,
} from "react-router-dom";

export async function loader({ params }) {
  // INFO: put loader logic in loader...
  // AKA if you need anything to relly on an await return, put it here.

  const Id = params.routeId;
  return null; //TODO: does nothing atm
}

export async function action({ params }) {
  return <div>hello</div>; //TODO: does nothing atm
}

export default function TestAction() {
  const loaderData = useLoaderData();

  console.log(loaderData);

  return (
    <div id="test-page">
      <h1 style={{color: 'white'}}>Great!</h1>
      <p>Things are working.</p>
      <div> here are params {loaderData}</div>
    </div>
  );
}